export default __webpack_public_path__ + "static/media/subscription-gold.ce05e780.svg";